import { createSlice } from "@reduxjs/toolkit";
import { aiApi } from "../api/ai.api";
import { IAIState } from "../types";

const initialState: IAIState = {
  audioUrlsForConstQuestionnaire: [],
};

export const AiSlice = createSlice({
  name: "ai",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      aiApi.endpoints.getAudioUrlsFromTexts.matchFulfilled,
      (state, { payload }) => {
        state.audioUrlsForConstQuestionnaire = payload.map((item: any) => ({
          questionId: item.id,
          audioUrl: item.url,
        }));
      }
    );
  },
});

export const { reducer: aiReducer } = AiSlice;
